import { urlEncodeUtil } from 'helpers/url-encode';
import { PaginationOutput } from 'kl-b2c-ui-kit';
import { FiltersType, HttpResponse, IApiService, IMediaApi, Media } from 'types';

export class MediaApi implements IMediaApi {
    constructor(private readonly apiService: IApiService) {}

    public get(params: FiltersType): Promise<HttpResponse<PaginationOutput<Media>>> {
        return this.apiService.request<PaginationOutput<Media>>({
            method: 'GET',
            url: '/Media/Get',
            params,
            paramsSerializer: urlEncodeUtil,
        });
    }
}
